define('SageDotCom/DataLayer/Events/callBackClick',[
        'jquery',
        'SageDotCom/DataLayer/Events/eventBase'
], function ($, EventBase) {

    function CallBackClickEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'contact_us'; // overwrite name
    }

    CallBackClickEvent.prototype = Object.create(EventBase.prototype);
    
    CallBackClickEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, label) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': '0',
            'event_category': 'contact',
            'event_action': 'callback'
        }
    
        if (scope) {
            var location = this.getLocation(scope);
            var lbl = label || $(scope).attr('data-title') || $(scope).text() || $('a:first', scope).text() || '';
            var id = getCallBackId(scope);

            eventData = $.extend(eventData, {
                'event_label': 'te llamamos', 
                'event_name_level_1': id,
                'event_name_level_2': '#callback',
                'event_name_level_3': 'call-back-popup',
                'event_name_level_4': location
            });
        }
    
        return eventData;
    }

    function getCallBackId(scope) {

        // Check if the scope itself has an id
        var scopeId = $(scope).attr('id');
        if (scopeId && scopeId !== '') {
            return scopeId;
        }

        var elem = $(scope).closest('[id]');

        if (elem) {
            return elem.attr('id');
        }

        return '';
    }

    return new CallBackClickEvent();
});
